import React from "react";

export default function CaseStudiesCard({ backgroundCol }) {
  return (
    <div
      className={`${
        backgroundCol ? backgroundCol : "bg-location-banner"
      }   items-center justify-center flex`}
    >
      <div className="mainContainer w-full 2xl:w-8/12 flex-col items-center justify-center py-28 flex text-white">
        <h2 className="text-[35px] pb-8 font-bold text-center">Case Studies</h2>

        <div className="cardParentDiv w-full flex flex-wrap md:flex-row items-center justify-center gap-x-6 gap-6">
          <div className="card lg:w-[30rem] w-full border border-midBlue rounded-[1.25rem] bg-midBlue p-8 leading-loose py-10 min-w-[280px]">
            <h3 className="text-xl font-bold">
              <span className="text-xl text-orange">English to Arabic</span>{" "}
              Legal Document Translation
            </h3>
            <p className="font-light py-6 text-[#BEBEBE]">
              A client requested an urgent translation from English to Arabic
              for a 1200 word legal document needed in a supreme court hearing.
              A pristine translation was needed in 24 hours. We delivered!
            </p>
            <a href="/recent-translations/english-to-arabic-legal-document-translation.php" className="border-b learnmore border-textgray text-xl font-light">
              GET STARTED
            </a>
          </div>
          <div className="card lg:w-[30rem] w-full border border-midBlue rounded-[1.25rem] bg-midBlue p-8 leading-loose py-10 min-w-[280px]">
            <h3 className="text-xl font-bold">
              <span className="text-xl text-orange">Chinese to English </span>{" "}
              Document Translation
            </h3>
            <p className="font-light py-6 text-[#BEBEBE]">
              A Chinese corporate client needed several Mandarin-to-English
              business documents to be translated urgently. She turned to our
              express service and a Chinese mother-tongue linguistic team
              started immediately. The quality, speed, and price of our work
              delighted her!
            </p>
            <a href="/recent-translations/chinese-english-business-document-translation-services" className="border-b learnmore border-textgray text-xl font-light">
              GET STARTED
            </a>
          </div>{" "}
          <div className="card lg:w-[30rem] w-full border border-midBlue rounded-[1.25rem] bg-midBlue p-8 leading-loose py-10 min-w-[280px]">
            <h3 className="text-xl font-bold">
              <span className="text-xl text-orange">Italian to English </span>{" "}
              Document Translation
            </h3>
            <p className="font-light py-6 text-[#BEBEBE]">
              Giovanni was applying to study at a UK university and needed
              certification of his educational qualifications from Italy. We
              assembled an Italian-British team of Italian to perform certified
              document translations. We delivered, and Gio got in!
            </p>
            <a href="/recent-translations/italian-english-document-translation" className="border-b learnmore border-textgray text-xl font-light">
              GET STARTED
            </a>
          </div>{" "}
          <div className="card lg:w-[30rem] w-full border border-midBlue rounded-[1.25rem] bg-midBlue p-8 leading-loose py-10 min-w-[280px]">
            <h3 className="text-xl font-bold">
              <span className="text-xl text-orange">English to Hindi </span>{" "}
              Document Translation
            </h3>
            <p className="font-light py-6 text-[#BEBEBE]">
              A client marketing to India had used a localization company that
              relied on machine translation, with unacceptable results. He
              required expert human translation of a presentation and brochure
              into Hindi within 12 hours. Could we help? Our DTP team delivered
              the goods in time.
            </p>
            <a href="/recent-translations/english-hindi-business-document-translation.php" className="border-b learnmore border-textgray text-xl font-light">
              GET STARTED
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
